import $ from 'jquery';

let $form = $('.js-form');
let $formControl = $('.js-form-control');

$formControl.on('change', handleFormControlEvent);
$formControl.on('keyup', handleFormControlEvent);

function handleFormControlEvent(event) {
  let $formControl = $(this);
  if ($formControl.val() && !$formControl.hasClass('has-value')) {
    $formControl.addClass('has-value');
  } else if (!$formControl.val() && $formControl.hasClass('has-value')) {
    $formControl.removeClass('has-value');
  }
}

let $gfield = $('.gfield');

// Add/remove `has-value` class (on `change` event) if input has value
$gfield.find('input, select, textarea').on('change', function (event) {
  let $this = $(this);
  let $gfield = $this.closest('.gfield');
  if ($this.val() && !$gfield.hasClass('has-value')) {
    $gfield.addClass('has-value');
  } else if (!$this.val() && $gfield.hasClass('has-value')) {
    $gfield.removeClass('has-value');
  }
});

// Add/remove `has-value` class (on `keyup` event) if input has value
$gfield.find('input, select, textarea').on('keyup', function (event) {
  let $this = $(this);
  let $gfield = $this.closest('.gfield');
  if ($this.val() && !$gfield.hasClass('has-value')) {
    $gfield.addClass('has-value');
  } else if (!$this.val() && $gfield.hasClass('has-value')) {
    $gfield.removeClass('has-value');
  }
});

// Add `has-focus` class (on `focusin` event)
$gfield.find('input, select, textarea').on('focusin', function (event) {
  let $this = $(this);
  let $gfield = $this.closest('.gfield');
  if (!$gfield.hasClass('has-focus')) {
    $gfield.addClass('has-focus');
  }
});

// Remove `has-focus` class (on `focusout` event)
$gfield.find('input, select, textarea').on('focusout', function (event) {
  let $this = $(this);
  let $gfield = $this.closest('.gfield');
  if ($gfield.hasClass('has-focus')) {
    $gfield.removeClass('has-focus');
  }
});
